// @ts-ignore esModuleInterop
import React from 'react'
// @ts-ignore no types
import { Alert, Button, Text } from '@adc/ui-adc'
import type { FeatureFlags } from '@adc/ui-adc'
import * as blueprint from '@adc/blueprint'
import * as graph from '@adc/sdk'
import { type AuctionBlueprintOnlineReactiveArgs } from '@adc/blueprint'
import { isPaymentTypeFclOnline } from 'common/utils/listing'
import {
  ILLINOIS_ONLINE_BID_DEPOSIT_LEARN_MORE_URL,
  NON_ONLINE_BID_DEPOSIT_LEARN_MORE_URL,
  ONLINE_BID_DEPOSIT_LEARN_MORE_URL,
} from 'common/statics'
import { useAiPrompt } from '../../context/aiPrompt'

interface BidDepositRequiredMessageProps {
  enableBidDepositRequiredMessage: boolean
  featureFlags: FeatureFlags
  listing: AuctionBlueprintOnlineReactiveArgs['listing']
  segment: AuctionBlueprintOnlineReactiveArgs['segment']
}

// TODO: once this doesn't need to get listing from property.listing from firstlookmodalbutton, update this to get listing from context
export const BidDepositRequiredMessage = ({
  enableBidDepositRequiredMessage,
  featureFlags,
  listing,
  segment,
}: BidDepositRequiredMessageProps) => {
  const { onClickAiPrompt } = useAiPrompt()
  const showBidDepositRequiredMessage =
    enableBidDepositRequiredMessage &&
    segment?.segment_status !== graph.enums.OnlineAuctionSegmentStatus.Ended

  const isWalletEnabled = featureFlags['fe.resi.enable-wallet']

  const shouldShowBidDepositRequiredMessage =
    showBidDepositRequiredMessage &&
    (isWalletEnabled
      ? listing.current_user_bid_deposit_requirements
          ?.is_registration_deposit_applicable
      : listing.online_auction_segment?.configuration
          ?.is_registration_deposit_required_enabled)

  const depositAmount =
    listing.current_user_bid_deposit_requirements?.absolute_amount_required

  const formattedAmount =
    isWalletEnabled && depositAmount
      ? blueprint.utils.formatMoney(depositAmount, {}, true)
      : '$999'
  const isPaymentTypeFclOnlineEnable = isPaymentTypeFclOnline(
    listing,
    featureFlags
  )

  const OnlineLearnMoreURL = isPaymentTypeFclOnlineEnable
    ? ILLINOIS_ONLINE_BID_DEPOSIT_LEARN_MORE_URL
    : ONLINE_BID_DEPOSIT_LEARN_MORE_URL

  const learnMoreURL = isWalletEnabled
    ? OnlineLearnMoreURL
    : NON_ONLINE_BID_DEPOSIT_LEARN_MORE_URL

  const headerMessage = isWalletEnabled
    ? `A fully refundable deposit of ${formattedAmount} is required to register.`
    : `A Deposit of ${formattedAmount} is required to complete the registration process; activation may take up to 2 business days.`

  const doAiPromptOnClick = !!(
    featureFlags['fe.resi.ai-assistant'] &&
    typeof featureFlags['fe.resi.ai-assistant'] === 'object' &&
    'enabled' in featureFlags['fe.resi.ai-assistant'] &&
    featureFlags['fe.resi.ai-assistant'].enabled
  )
  if (shouldShowBidDepositRequiredMessage && isPaymentTypeFclOnlineEnable) {
    return (
      <Alert
        style={{ textAlign: 'initial' }}
        role='caution'
        header='Registration Deposit Required'
        content={
          <Text size='tiny' color='caution'>
            {`A Registration Deposit of ${formattedAmount} is required to bid.`}{' '}
            <a
              data-elm-id='bid_deposit_learn_more'
              href={doAiPromptOnClick ? undefined : learnMoreURL}
              onClick={e => {
                if (doAiPromptOnClick) {
                  e.preventDefault()
                  onClickAiPrompt(
                    `When will I get a refund for my ${formattedAmount} deposit? And how?`
                  )
                }
              }}
              target='_blank'
              rel='noreferrer'
              style={{ color: 'inherit', textDecoration: 'underline' }}
            >
              Learn more.
            </a>
          </Text>
        }
      />
    )
  }

  return shouldShowBidDepositRequiredMessage ? (
    <Alert
      style={{ textAlign: 'initial' }}
      role='info'
      header={headerMessage}
      slots={{
        action: () => (
          <Button
            data-elm-id='bid_deposit_learn_more'
            tag='a'
            link={doAiPromptOnClick ? null : learnMoreURL}
            onClick={() => {
              if (doAiPromptOnClick) {
                onClickAiPrompt(
                  `When will I get a refund for my ${formattedAmount} deposit? And how?`
                )
              }
            }}
            target='_blank'
            rel='noreferrer'
          >
            Learn More
          </Button>
        ),
      }}
    />
  ) : null
}
